// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBUZ25mZlo-aAe2w8V5H0AVoslb2eTg_5k",
  authDomain: "stockarchives-1839d.firebaseapp.com",
  projectId: "stockarchives-1839d",
  storageBucket: "stockarchives-1839d.firebasestorage.app",
  messagingSenderId: "601355207990",
  appId: "1:601355207990:web:e061149c11364e47e8df97",
  measurementId: "G-XQP3K1061L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export auth
const auth = getAuth(app);

export { auth };